<div class="container">
  <div class="col-12 cancel-bottom-padding">
    <div class="rfq-header">Select Services</div>
    <div class="rfq-subheader">Please select the services for which you would like learn more!</div>
  </div>
  <div class="row row-cols-2 col-12 no-gutter">
    <div class="col col-6">
      <div class="col-12">
        <p-checkbox name="treePruning" group="servicesGroup" [binary]="true" [disabled]="isDisabled"
          [(ngModel)]="quoteRequest.needsPruning" inputId="pruning"></p-checkbox>
        <label for="treePruning">Tree Pruning</label>
      </div>
      <div class="col-12">
        <p-checkbox name="treeRemoval" group="servicesGroup" [binary]="true" [disabled]="isDisabled"
          [(ngModel)]="quoteRequest.needsRemoval" inputId="removal"></p-checkbox>
        <label>Tree Removal</label>
      </div>
      <div class="col-12 less-top-no-bottom-padding">
        <p-checkbox name="stumpRemoval" group="servicesGroup" [binary]="true" [disabled]="isDisabled"
          [(ngModel)]="quoteRequest.needsStumpRemoval" inputId="stumpRemoval"></p-checkbox>
        <label>Stump Removal</label>
      </div>
      <div class="col-12 less-top-no-bottom-padding">
        <p-checkbox name="fertizialtion" group="servicesGroup" [binary]="true" [disabled]="isDisabled"
          [(ngModel)]="quoteRequest.needsFertilization" inputId="fertilization"></p-checkbox>
        <label>Fertilization</label>
      </div>
      <div class="col-12 less-top-no-bottom-padding">
        <p-checkbox name="insectAndDisease" group="servicesGroup" [binary]="true" [disabled]="isDisabled"
          [(ngModel)]="quoteRequest.needsInsectOrDiseaseControl" inputId="insectrOrDisease"></p-checkbox>
        <label for="insectAndDisease">Insect & Disease Management</label>
      </div>
      <div class="col-12 less-top-no-bottom-padding">
        <p-checkbox name="cabling" group="servicesGroup" [binary]="true" [disabled]="isDisabled"
          [(ngModel)]="quoteRequest.needsCablingAndBracing" inputId="cablingAndBracing"></p-checkbox>
        <label>Cabling & Bracing</label>
      </div>
    </div>
    <div class="col col-6">
      <div class="col-12 less-top-no-bottom-padding">
        <p-checkbox name="lightingProtection" group="servicesGroup" [binary]="true" [disabled]="isDisabled"
          [(ngModel)]="quoteRequest.needsLightningProtection" inputId="lighting"></p-checkbox>
        <label>Lighting Protection</label>
      </div>
      <div class="col-12 less-top-no-bottom-padding">
        <p-checkbox name="clearing" group="servicesGroup" [binary]="true" [disabled]="isDisabled"
          [(ngModel)]="quoteRequest.needsLotClearingAndForestryMower" inputId="clearingAndMowing"></p-checkbox>
        <label>Clearing & Forestry Mowing</label>
      </div>
      <div class="col-12 less-top-no-bottom-padding">
        <p-checkbox name="rootManagement" group="servicesGroup" [binary]="true" [disabled]="isDisabled"
          [(ngModel)]="quoteRequest.needsRootZoneManagement" inputId="rootZone"></p-checkbox>
        <label>Root Zone Management</label>
      </div>
      <div class="col-12 less-top-no-bottom-padding">
        <p-checkbox name="treeRisk" group="servicesGroup" [binary]="true" [disabled]="isDisabled"
          [(ngModel)]="quoteRequest.needsTreeRiskAssessment" inputId="riskAssessment"></p-checkbox>
        <label>Tree Risk Assessment</label>
      </div>
      <div class="col-12 less-top-no-bottom-padding">
        <p-checkbox name="treePreservation" group="servicesGroup" [binary]="true" [disabled]="isDisabled"
          [(ngModel)]="quoteRequest.needsPreConstructionTreeConsulting" inputId="preservation"></p-checkbox>
        <label>Tree Preservation</label>
      </div>
      <div class="col-12 less-top-no-bottom-padding">
        <p-checkbox name="treeMapping" group="servicesGroup" [binary]="true" [disabled]="isDisabled"
          [(ngModel)]="quoteRequest.needsTreeMapping" inputId="treeMapping"></p-checkbox>
        <label>Tree Mapping</label>
      </div>
    </div>
  </div>
</div>